import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/890678b76044437f323ed90104536ad4.jpg"
          alt="CPR class Kissimmee"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-brand-purple/88" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <span className="inline-block border border-brand-gold/50 text-brand-gold text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-6">
          Same-Day Classes &amp; Certification Available
        </span>
        <h2 className="font-serif text-4xl lg:text-5xl font-bold text-white mb-6">
          Ready to Get Certified?
          <br />
          <span className="text-brand-gold">Reserve Your Spot Today</span>
        </h2>
        <p className="text-white/80 text-lg leading-relaxed mb-10 max-w-2xl mx-auto">
          Join hundreds of Kissimmee professionals who chose Cardiocraft CPR for
          expert RN-led training. Same-day BLS certification, ACLS, PALS, and more.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to="/booking#reserve-spot"
            className="bg-brand-gold text-brand-black font-bold text-base px-10 py-4 rounded-md hover:bg-brand-gold-dark transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-calendar-check-line mr-2" />
            Book Your Class Now
          </Link>
          <Link
            to="/courses"
            className="border-2 border-white/50 text-white font-semibold text-base px-10 py-4 rounded-md hover:border-white hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
          >
            Explore All Courses
          </Link>
        </div>
      </div>
    </section>
  );
}
